import React from "react";
import { useNavigate } from "react-router-dom";

export default function AccountValidate() {
  const navigate = useNavigate();

  return (
    <div className="flex flex-col items-center w-full">

      {/* Back button */}
      <div className="w-full max-w-6xl px-4 pt-3">
        <button
          onClick={() => navigate(-1)}
          className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 text-sm"
        >
          ← Volver
        </button>
      </div>

      {/* Title */}
      <h1 className="text-lg font-semibold mt-2 mb-3 text-center w-full px-4">
        Cuenta validada - Realty Shot
      </h1>

      {/* Content */}
      <div className="w-full max-w-3xl px-4 text-sm text-gray-700">
        <p className="mb-3">
          ¡Cuenta validada correctamente!
        </p>

        <p className="text-xs text-gray-500">
          Podes cerrar esta ventana y volver a la app.
        </p>
      </div>
    </div>
  );
}